import queryString from 'query-string';

export const SEARCH_MIN_CHARACTERS = 3;

export function parseQuery(search) {
  return queryString.parse(search, { arrayFormat: 'bracket' });
}

export function cleanQuery(obj) {
  const check = (str) => (typeof str === 'string' || Array.isArray(str) ? Boolean(str.length) : false);

  return Object.keys(obj).reduce((A, V) => (check(obj[V]) ? { ...A, [V]: obj[V] } : A), {});
}

export function queryToSearch(query) {
  return queryString.stringify(query, { arrayFormat: 'bracket' });
}

export function queryToSupplierUpload(query) {
  return queryString.stringify(query);
}

export const addQueryToUrl = (url, queryParams) => {
  const queryStr = queryToSearch(queryParams);
  const glue = url.indexOf('?') > -1 ? '&' : '?';

  return [url, glue, queryStr].join('');
};

export const hrefObjectToString = (path) => {
  const { pathname, search } = path;
  const glue = search.indexOf('?') > -1 ? '' : '?';

  return [pathname, glue, search].join('');
};
